import * as React from "react";

function SvgIcPrinter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path 
        d="M19.5 7.5H18.5V2.5H6.5V7.5H5.5C3.846 7.5 2.5 8.846 2.5 10.5V17.5C2.5 18.603 3.397 19.5 4.5 19.5H6.5V22.5H18.5V19.5H20.5C21.603 19.5 22.5 18.603 22.5 17.5V10.5C22.5 8.846 21.154 7.5 19.5 7.5ZM8.5 4.5H16.5V7.5H8.5V4.5ZM16.5 20.5H8.5V16.5H16.5V20.5ZM20.5 17.5H18.5V16.5V14.5H6.5V16.5V17.5H4.5V10.5C4.5 9.949 4.949 9.5 5.5 9.5H19.5C20.052 9.5 20.5 9.949 20.5 10.5V17.5Z" 
        fill="currentColor"/>
      <path 
        d="M14.5 10.5H18.5V12.5H14.5V10.5Z" 
        fill="currentColor"/>
    </svg>
  );
}

export default SvgIcPrinter;
